import * as React from 'react';

import { useParams } from 'js/lib/useRouter';
import { isAuthenticatedUser } from 'js/lib/user';

import { showPathwaysUserBased } from 'bundles/unified-common/utils/showPathways';
import CareerRolesDataContext from 'bundles/unified-description-page-common/contexts/CareerRolesDataContext';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import useCareerRolesQuery from 'bundles/unified-description-page-common/hooks/useCareerRolesQuery';

type Props = {
  children: React.ReactNode;
  productType: 'SPECIALIZATION' | 'COURSE';
};

const CareerRolesDataProvider = ({ children, productType }: Props) => {
  const { productSlug } = useParams();

  const { isCareerRolePathway } = useSpecializationPageData() ?? {};

  const { loading, data, eventingPathwaysData } = useCareerRolesQuery({
    skip: !productSlug || !isCareerRolePathway || (isAuthenticatedUser() && !showPathwaysUserBased()),
    productSlug,
    productType,
  });

  return (
    <CareerRolesDataContext.Provider value={{ loading, data: data?.entities, eventingPathwaysData }}>
      {children}
    </CareerRolesDataContext.Provider>
  );
};

export default CareerRolesDataProvider;
